<div class="row">
  <div class="col-xs-12 col-sm-12 col-md-8 p-0 m-0">
    <app-user-header [selectedHeader]="header" [tableCategory]="creditInvoice"></app-user-header>

    <div class="col-xs-12 col-sm-12 col-md-12 Registration-split user-information-view">
      <h3 class="pdp-title">
        {{ "userRegistration.userInformation.pageHeader" | cxTranslate }}
      </h3>

      <div id="location-box">
        <div class="locationIcon">
          <img class="locationicon-align" src="/icons/{{baseSiteId}}/location.svg" alt="location" />
        </div>
        @if (accountData) {
          <div class="locationDetails">
            <span class="selected-loc">{{accountData?.accountname}} ({{accountData?.accountnumber}})</span>
            <span class="change-loc focus" data-toggle="modal" data-keyboard="true" data-target="#location-sel-popup"
              tabindex="0">
              {{ "userRegistration.userInformation.locationStripSubMessage" | cxTranslate }}
            </span>
          </div>
        }
      </div>
      <span class="title-sub-heading">
      {{ "userRegistration.userInformation.formTitle" | cxTranslate }}</span>

      <form [formGroup]="userInfoForm" id="userInfoForm" (ngSubmit)="submitUserInfo()" autocomplete="off">
        <div class="col-xs-12 col-sm-6 col-md-6 p0">
          <div id="registerAccount">
            <div formGroupName="userInfoDetails">
              <div class="col-xs-12 col-sm-12 col-md-12 p0 Fields-container doubleLineContainer">
                <label for="username" class="Fields-label icon-label">
                  {{ "userRegistration.userInformation.username.label" | cxTranslate }}
                </label>
                <ng-template #popContent>
                  {{ "userRegistration.userInformation.username.popover_msg_1" | cxTranslate }} <br />
                  {{ "userRegistration.userInformation.username.popover_msg_2" | cxTranslate }} <br />
                  {{ "userRegistration.userInformation.username.popover_msg_3" | cxTranslate }}
                </ng-template>
                <a placement="top" [ngbPopover]="popContent" class="Fields-label icon-label"
                  popoverClass="usernametooltip-popover"><img src="/icons/{{baseSiteId}}/faqs-plum.svg"
                alt="faq_reg" class="faq" /></a>
                <input id="username" name="userName" data-valid="valid_facility"
                  aria-labelledby="userName tooltipFacilityName" type="text" class="Fields-input user"
                  autocomplete="off" formControlName="userName" data-di-id="#userName" maxlength="10" />

                @if (isUsernameExists && !userInfoForm.get('userInfoDetails.userName').touched) {
                  <span
                    class="errorMessage">
                    {{ "userRegistration.userInformation.username.existingUsernameMsg" | cxTranslate }}
                  </span>
                }

                @if (!!userInfoForm.get('userInfoDetails.userName').value
                  && !userInfoForm.get('userInfoDetails.userName').valid
                  && userInfoForm.get('userInfoDetails.userName').errors?.sameAsaccountNo
                  && userInfoForm.get('userInfoDetails.userName').touched) {
                  <span class="errorMessage">
                    {{ "userRegistration.userInformation.username.usernameSameAsAccountNo" | cxTranslate }}
                  </span>
                }

                @if (!!userInfoForm.get('userInfoDetails.userName').value
                  && !userInfoForm.get('userInfoDetails.userName').valid
                  && !userInfoForm.get('userInfoDetails.userName').errors?.sameAsaccountNo
                  && userInfoForm.get('userInfoDetails.userName').touched) {
                  <span class="errorMessage">
                    {{ "userRegistration.userInformation.username.inValidUsername" | cxTranslate }}
                  </span>
                }

                @if (!!userInfoForm.get('userInfoDetails.userName').value
                  && !userInfoForm.get('userInfoDetails.userName').valid
                  && !userInfoForm.get('userInfoDetails.userName').errors?.sameAsaccountNo
                  && userInfoForm.get('userInfoDetails.userName').touched) {
                  <span class="errorMessage">
                  {{ "userRegistration.userInformation.username.inValidUsername" | cxTranslate }} </span>
                }
                @if (userInfoForm.get('userInfoDetails.userName').errors?.required
                  && !userInfoForm.get('userInfoDetails.userName').valid
                  && userInfoForm.get('userInfoDetails.userName').touched) {
                  <span class="defaultMessage" role="alert"
                    aria-live="assertive">
                    {{ "userRegistration.userInformation.requiredMsg" | cxTranslate }}
                  </span>
                }
              </div>
            </div>
          </div>
        </div>
        <hr class="Fields-container-line billingPage" />
        <h3 class="pdp-title">
          {{ "userRegistration.userInformation.subTitle" | cxTranslate }}
        </h3>
        <div class="col-xs-12 col-sm-6 col-md-6 p0">
          <div id="registerBilling">
            <div class="col-xs-12 col-sm-12 col-md-12 p0 Fields-container doubleLineContainer">
              <label for="userFirstName" class="Fields-label">
                {{ "userRegistration.userInformation.firstName.label" | cxTranslate }}
              </label>
              <input id="userFirstName" name="firstName" data-valid="valid_facility" maxlength="40"
                aria-labelledby="firstName tooltipFacilityName" type="text" class="Fields-input" autocomplete="off"
                formControlName="firstName" data-di-id="#userFirstName" />
              @if (userInfoForm.get('firstName').value.length != 0
                && userInfoForm.get('firstName').invalid
                && (userInfoForm.get('firstName').touched
                || userInfoForm.get('firstName').dirty)) {
                <span class="defaultMessage" role="alert">
                  Enter a valid first name
                </span>
              }
              @if (userInfoForm.get('firstName').errors?.required
                && !userInfoForm.get('firstName').valid
                && userInfoForm.get('firstName').touched) {
                <span class="defaultMessage" role="alert" aria-live="assertive">
                  {{ "userRegistration.userInformation.requiredMsg" | cxTranslate }}
                </span>
              }
            </div>

            <div class="col-xs-12 col-sm-12 col-md-12 p0 Fields-container doubleLineContainer">
              <label for="userLastName" class="Fields-label">
                {{ "userRegistration.userInformation.lastName.label" | cxTranslate }}
              </label>
              <input id="userLastName" name="lastName" data-valid="valid_facility" maxlength="40"
                aria-labelledby="lastName tooltipFacilityName" type="text" class="Fields-input" autocomplete="off"
                formControlName="lastName" data-di-id="#userLastName" />
              @if (userInfoForm.get('lastName').value.length != 0
                && userInfoForm.get('lastName').invalid
                && (userInfoForm.get('lastName').touched
                || userInfoForm.get('lastName').dirty)) {
                <span class="defaultMessage" role="alert">
                  Enter a valid last name
                </span>
              }
              @if (userInfoForm.get('lastName').errors?.required
                && !userInfoForm.get('lastName').valid
                && userInfoForm.get('lastName').touched) {
                <span class="defaultMessage" role="alert" aria-live="assertive">
                  {{ "userRegistration.userInformation.requiredMsg" | cxTranslate }}
                </span>
              }
            </div>
            <div class="col-xs-12 col-sm-12 col-md-8 p0 Fields-container asses_dropdown">
              <label for="primaryRole" id="roleLabel" class="Fields-label">
                {{ "userRegistration.userInformation.role.label" | cxTranslate }}
              </label>
              <div>
                <div>
                  <ng-select name="role" [items]="contactRole" [searchable]="false" [clearable]="false" bindLabel="name"
                  bindValue="code" placeholder="Select" formControlName="role" class="dropdown-credit"></ng-select>
                </div>
                @if (userInfoForm.get('role').errors?.required
                  && !userInfoForm.get('role').valid
                  && userInfoForm.get('role').touched) {
                  <span class="errorMessage" role="alert" aria-live="assertive">
                    {{ "userRegistration.userInformation.requiredMsg" | cxTranslate }}
                  </span>
                }
              </div>
            </div>
          </div>
        </div>
        <hr class="Fields-container-line billingPage" />
        <h3 class="pdp-title">
          {{ "userRegistration.userInformation.anotherSubTitle" | cxTranslate }}
        </h3>
        <div>
          <label for="userEmailConsent" id="usrEmailConsentLabel" class="Fields-label-new">
            {{ "userRegistration.userInformation.emailConsent.label" | cxTranslate }}
          </label>
          <div class="custom-control custom-control-inline acceptmail-margin-align">
            <input type="radio" id="acceptEmailConsent" name="emailConsent" [value]="isEmailConsent[0]"
              formControlName="emailConsent" class="custom-radio" />
            <label class="custom-control-label" for="acceptEmailConsent">
              {{ "userRegistration.userInformation.emailConsent.accepted" | cxTranslate }}
            </label>
          </div>
          <div class="custom-control custom-control-inline">
            <input type="radio" id="rejectEmailConsent" name="emailConsent" [value]="isEmailConsent[1]"
              formControlName="emailConsent" class="custom-radio" />
            <label class="custom-control-label" for="rejectEmailConsent">
              {{ "userRegistration.userInformation.emailConsent.rejected" | cxTranslate }}
            </label>
          </div>
        </div>
        @if (!altEmailSection && userInfoForm.get('emailConsent').value) {
          <span class="addAlternateEmail" (click)="addAlternateEmail()"
            >
            {{ "userRegistration.userInformation.alternateEmail.title" | cxTranslate }}
          </span>
        }
        @if (altEmailSection && userInfoForm.get('emailConsent').value) {
          <div class="noemailUpdates" style="display: block"
            >
            <div formGroupName="alternateEmailInfo">
              <div class="col-xs-12 col-sm-12 col-md-12 p0 Fields-container">
                <div class="col-xs-12 col-sm-6 col-md-6 p0 Fields-container">
                  <label for="altEmail" class="Fields-label">
                    {{ "userRegistration.userInformation.alternateEmail.label" | cxTranslate }}
                  </label>
                  <input id="altEmail" name="alternateEmail" data-valid="valid_mail" type="text"
                    class="Fields-input field-optional" data-view="altemail" formControlName="alternateEmail"
                    autocomplete="off" data-di-id="#altEmail" />
                  @if ((userInfoForm.get('alternateEmailInfo.alternateEmail').errors?.email
                    || userInfoForm.get('alternateEmailInfo.alternateEmail').errors?.pattern)
                    && !userInfoForm.get('alternateEmailInfo.alternateEmail').valid
                    && userInfoForm.get('alternateEmailInfo.alternateEmail').touched) {
                    <span class="defaultMessage" role="alert"
                      aria-live="assertive">
                    {{ "userRegistration.userInformation.email.invalidEmail" | cxTranslate }} </span>
                  }
                  @if (userInfoForm.get('alternateEmailInfo.alternateEmail').errors?.required
                    && !userInfoForm.get('alternateEmailInfo.alternateEmail').valid
                    && userInfoForm.get('alternateEmailInfo.alternateEmail').touched) {
                    <span class="defaultMessage" role="alert"
                      aria-live="assertive">
                      {{ "userRegistration.userInformation.requiredMsg" | cxTranslate }}
                    </span>
                  }
                  <label for="confirmAltEmail" class="Fields-label">
                    {{ "userRegistration.userInformation.alternateEmail.confirm_alt_email_label" | cxTranslate }}
                  </label>
                  <input id="confirmAltEmail" name="confirmAlternateEmail" data-valid="valid_mail" type="text"
                    class="Fields-input field-optional" data-view="confirmaltemail"
                    formControlName="confirmAlternateEmail" autocomplete="off" data-di-id="#confirmAltEmail" />
                  @if ((userInfoForm.get('alternateEmailInfo.confirmAlternateEmail').errors?.email
                    || userInfoForm.get('alternateEmailInfo.confirmAlternateEmail').errors?.pattern)
                    && !userInfoForm.get('alternateEmailInfo.confirmAlternateEmail').valid
                    && userInfoForm.get('alternateEmailInfo.confirmAlternateEmail').touched) {
                    <span class="defaultMessage"
                      role="alert" aria-live="assertive">
                      {{ "userRegistration.userInformation.email.invalidEmail" | cxTranslate }}
                    </span>
                  }
                  @if (!!userInfoForm.get('alternateEmailInfo.confirmAlternateEmail').value
                    && !userInfoForm.get('alternateEmailInfo.confirmAlternateEmail').invalid
                    && userInfoForm.get('alternateEmailInfo').errors?.altEmailNotMatch) {
                    <span class="errorMessage">
                      {{ "userRegistration.userInformation.notMatchMsg" | cxTranslate }}
                    </span>
                  }
                  @if (userInfoForm.get('alternateEmailInfo.confirmAlternateEmail').errors?.required
                    && !userInfoForm.get('alternateEmailInfo.confirmAlternateEmail').valid
                    && userInfoForm.get('alternateEmailInfo.confirmAlternateEmail').touched) {
                    <span class="defaultMessage"
                      role="alert" aria-live="assertive">
                      {{ "userRegistration.userInformation.requiredMsg" | cxTranslate }}
                    </span>
                  }
                </div>
                <div class="col-xs-12 col-sm-4 col-md-4 p0 Fields-container deleteAlign">
                  <a (click)="deleteAltEmailSection()" title="" class="alternate-mail-delete"
                    data-di-id="di-id-503c60dc-e8d584e6">
                    <img src="/icons/{{baseSiteId}}/trash.svg" alt="Delete" />
                    {{ "userRegistration.userInformation.alternateEmail.delete_alt_section_text" | cxTranslate }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        }
        @if (altEmailSection && userInfoForm.get('emailConsent').value) {
          <hr
            class="Fields-container-line userInfoPage" />
        }
        <div class="invoice-btngrps" [ngClass]="!!altEmailSection && userInfoForm.get('emailConsent').value
          ? 'alt-section'
          : ''">
          <button type="submit" class="btn-primary" data-di-id="di-id-7a6cb2cd-cb37948a">
            {{ "userRegistration.userInformation.submit_button" | cxTranslate }}
          </button>
        </div>
      </form>
    </div>
  </div>
  <div class="col-xs-12 col-sm-12 col-md-4 needCls needCls2" [innerHTML]="(finalNeedAss | async)?.content">
  </div>
</div>
